export default {
  methods: {
    usuarioGrafico (e) {
      e.preventDefault()
      let item = e.sender.dataItem(e.masterRow)
      // eslint-disable-next-line no-undef
      $('<div/>').appendTo(e.detailCell).kendoChart({
        dataSource: {
          transport: {
            read: {
              url: `${this.$url}/relatorio/usuarios/data`,
              data: {
                dataini: this.filtro.dataini,
                datafim: this.filtro.datafim,
                usuario: item.usuario_id,
                status: this.filtro.status,
                datatipo: this.filtro.datatipo
              }
            }
          },
          schema: {
            parse: data => {
              return data.map(item => {
                item.v1 = parseFloat(item.v1)
                return item
              })
            }
          },
          group: {
            field: 'usuario_nome'
          }
        },
        legend: {
          visible: false
        },
        seriesDefaults: {
          type: 'column',
          labels: {
            visible: true,
            background: 'transparent'
          }
        },
        valueAxis: {
          type: 'log',
          title: {
            text: 'Valor'
          }
        },

        series: [{
          field: 'v1',
          name: 'Valor',
          format: '{0:n}',
          tooltip: {
            visible: true
          }
        }, {
          field: 'quant',
          name: 'Quant',
          tooltip: {
            visible: true
          }
        }],
        theme: 'material',
        categoryAxis: {
          field: 'nome',
          name: 'Dias',
          majorGridLines: {
            visible: true
          },
          line: {
            visible: true
          },
          title: {
            text: 'Dias'
          },
          labels: {
            rotation: 'auto'
          }
        }
      })
    }
  }
}
